import type { FaireProductEntity } from "../../entity_types/product";

export const p_eza98cmtqb: FaireProductEntity = {
  token: "p_eza98cmtqb",
  type: "product",
  name: "Cactus Scene everyday greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/79df121ba6e3185b616bba325be79567f1e124a321793251fd966735f7dfce0d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3a8ff73174cca360c41ef9a0b8f95392eaa79c827835afd3b715d2d8c2d880e4.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "• Blank inside.\n• 100lb heavyweight card stock.\n• Offset printed.\n• 5.5 x 4.25 inches.\n• Illustrated by Caroline Clark.\n• Printed by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\n\nAvailable as both single cards and pre-packaged boxed cards.\n\n• Each single card comes with an envelope and a cellophane sleeve.\n• Boxed sets are 8 cards with envelopes and are to be sold as packaged, not to be re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:20:47.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
